module.exports = __webpack_public_path__ + "img/impostor-silhouete-1.92cc6451.png";